import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { Box, Grid, List, ListItem, ListItemText, Typography } from "@mui/material";
import StarRatingoComponent from "../../atom/Buttons/StarRating";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { VideoListView } from '../../atom';
import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import _ from "lodash"
import { useDispatch } from 'react-redux';
import { Actions } from '../../../core/modules/Actions';
import TextButtonComponet from '../../atom/Buttons/TextButton';
import { COURSE_SECTION_TYPE_ID } from '../../../core/Constant';
import { baseappURL } from '../../../core/repository/Repository';
import WaterMark from '@uiw/react-watermark';
import UserRepository from '../../../core/repository/UserRepository';
import { useWatermarkProtection } from '../../../hook/useWatermarkProtection';

const MarkAsinCompletedText = ({ isCompleted = false, onPress = () => { } }) => {
  return (
    <Box
      sx={{
        ".Mui-expanded & > .collapsIconWrapper": {
          display: "none"
        },
        ".expandIconWrapper": {
          display: "none"
        },
        ".Mui-expanded & > .expandIconWrapper": {
          display: "block"
        }
      }}
    >
      <Grid style={{ flexDirection: 'row', justifyContent: 'flex-end' }} container>
        <Grid item xs={4} sm={4} md={4} lg={3} > <TextButtonComponet
          text={isCompleted ? "Mark As Incomplete" : "Mark As Complete"} classStyle={isCompleted ? "btn btn-primary" : "btn btn-secondary"} width={120} onButtonClick={() => {
            onPress()
          }}
        /></Grid>
      </Grid>
    </Box>
  );
};



const CourseListCard = ({ courseData, isRegistered, isExpired = false, onEnroll = () => {}, contentNamesOnly = false }) => {
  const navigate = useNavigate();
  const location = useLocation()
  const [dataList, setDataList] = useState([]);
  const [hide, setHide] = useState(false);
  const [expandedPreviewSections, setExpandedPreviewSections] = useState([]);
  const [userInfo, setUserInfo] = useState({ name: '', contact: '', email: '' });
  const [watermarkKey, setWatermarkKey] = useState(0);
  const hasTriggeredWatermarkAlert = React.useRef(false);
  const dispatch = useDispatch()
  const hasFullCourseAccess = Boolean(isRegistered) && !isExpired;

  useWatermarkProtection({
    wrapperSelector: '.course-list-watermark-protection',
    watermarkSelector: '.w-watermark',
    onTamper: () => {
      if (!hasTriggeredWatermarkAlert.current) {
        hasTriggeredWatermarkAlert.current = true;
        UserRepository.temperingAlertMail().catch((error) => {
          console.error('Failed to send watermark tampering alert:', error);
        });
      }
      setWatermarkKey((currentKey) => currentKey + 1);
    },
  });

  useEffect(() => {
    // const flatData = _.flattenDeep(courseData);
    const flatData = _.flatMap(courseData, week =>
      _.flatten(_.values(week))
    );

    const list = _(flatData)
      .groupBy("week")
      .values()
      .map(item => {
        const grouped = _(item)
          .map(i => ({
            ...i,
            day: i.day == null || i.day === "" || i.day === 0 ? 1000 : i.day
          }))
          .groupBy("day")
          .values()
          .value();

        return _.sortBy(grouped, g => {
          const dayNum = Number(g[0]?.day);
          return dayNum === 1000 ? -1 : dayNum;
        });
      })
      .value();
    setDataList(list);
  }, [courseData]);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const user = await UserRepository.getUserDetail();
        setUserInfo({
          name: `${user?.data?.first_name || ''} ${user?.data?.last_name || ''}`.trim(),
          contact: user?.data?.phone_number || '',
          email: user?.data?.email || '',
        });
      } catch (error) {
        console.error('Failed to load user details for course watermark:', error);
      }
    };

    fetchUserInfo();
  }, []);

  const onNavigatetoPreview = (value, item, isCompleted) => {
    const token = localStorage.getItem('token');
    const hasToken = token && token.length > 1;
    const isVideo = Number(value.content_type) === COURSE_SECTION_TYPE_ID.VIDEO;

    if (hasToken) {
      switch (Number(value.content_type)) {
        case COURSE_SECTION_TYPE_ID.VIDEO:
          navigate('/course-video', {
            state: { course: { ...value, isCompleted }, courselist: item }
          });
          break;
        case COURSE_SECTION_TYPE_ID.QUIZ:
          dispatch(Actions.quizes.quizStateChange(false));

          const hasExistingAttempts = value?.students_course_status?.length > 0;

          navigate('/quiz-main', {
            state: { quizData: { ...value, 
              id: value.quiz_id, 
              duration: value.duration,
              returnPath: location?.pathname 
            },
          resume: hasExistingAttempts
        }
          });
          break;
        case COURSE_SECTION_TYPE_ID.DOCUMENT:
          const document = {
            id: Number(value.content_link),
            name: value.document_name
          }
          navigate("/view-document", {
            state: {
              document,
              baseurl: baseappURL,
              returnPath: -1,
            },
          });
          break;
        default:
          break;
      }
    } else if (isVideo) {
      navigate('/course-video-free', {
        state: { course: value, courselist: item }
      });
    }
  };

  const setOnHide = (item) => {
    if (hide == true) {
      setHide(true)
    }
    else {
      setHide(false)
    }
  }

  const CustomExpandText = (canExpand) => (
      <Box
        sx={{
          ".Mui-expanded & > .collapsIconWrapper": {
            display: "none"
          },
          ".expandIconWrapper": {
            display: "none"
          },
          ".Mui-expanded & > .expandIconWrapper": {
            display: "block"
          }
        }}
      >{canExpand && (
        <>
        <div className="expandIconWrapper">
          <Typography sx={{
            fontFamily: 'Montserrat',
            fontSize: '16px',
            color: 'rgb(152, 52, 240)', flex: 0.2
          }}>Hide Details</Typography>
        </div>
          <div className="collapsIconWrapper">
            <Typography sx={{
              fontFamily: 'Montserrat',
              fontSize: '16px',
              color: 'rgb(152, 52, 240)', flex: 0.2
            }}>Show Details</Typography>
          </div>
        </>
        )}
      </Box>
    );

  const onMarkAsCompleteOrInComplete = (isCompleted, data) => {
    const courseId = _.get(data, '[0].course_id', 0);
    const list = _.map(data, (item, index) => {
      return item?.id

    })
    if (isCompleted) {
      dispatch(Actions.course.setVideosInCompleted({ list, courseId }))
    } else {
      dispatch(Actions.course.setVideoCompleted({ course_content_ids: list, courseId }))
    }

  }

  return (<Box sx={{
    width: '100%',
    alignSelf: 'center'
  }}>
    <Box className="course-list-watermark-protection">
      <WaterMark
        key={watermarkKey}
        content={[userInfo.name, userInfo.contact, userInfo.email]}
        gap={[120, 120]}
        fontSize={12}
        rotate={-20}
        fontColor="rgba(0, 0, 0, 0.18)"
        style={{ display: 'block', width: '100%' }}
      >
        {dataList.map((item, index) => {
        if (contentNamesOnly) {
          return (
            <Box
              key={`course-content-name-${index}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
                minHeight: 48,
                px: 2,
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
              }}
            >
              <Typography sx={{
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontWeight: '600',
                color: '#2d3945',
              }}>{item[0][0].week}</Typography>
            </Box>
          );
        }

        const canExpand = hasFullCourseAccess || index < 2;
        const isExpanded = hasFullCourseAccess
          ? undefined
          : expandedPreviewSections.includes(index);
        const list = _(item).flatten().filter(i => i?.students_course_status?.length > 0).value();
        const isCompleted = list?.length > 0;
        return (
          <Accordion
            sx={{ boxShadow: 0 }}
            expanded={hasFullCourseAccess ? undefined : isExpanded}
            onChange={(_, expanded) => {
              if (!hasFullCourseAccess && index < 2) {
                setExpandedPreviewSections((current) =>
                  expanded
                    ? [...current, index]
                    : current.filter((sectionIndex) => sectionIndex !== index)
                );
              }
            }}
            disableGutters
          >
            <AccordionSummary
              expandIcon={ <ExpandMoreIcon sx={{ color: "rgb(152, 52, 240)", visibility: canExpand ? "visible" : "hidden", }} />}
              aria-controls="panel1a-content"
              id={item[index]}
              exp
              sx={{ display: 'flex', flexDirection: 'row', width: 1, flex: 1 }}
              onClick={() => hasFullCourseAccess && setOnHide()}
            >
              <Typography sx={{
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontWeight: '600',
                color: '#2d3945',
                flex: 1,
                minWidth: 0,
              }}>{item[0][0].week}</Typography>
              <Box sx={{ width: { xs: 140, sm: 200 }, flexShrink: 0 }}>
                {canExpand ? CustomExpandText(true) : (
                  <Typography
                    component="span"
                    role="button"
                    tabIndex={0}
                    onClick={(event) => {
                      event.stopPropagation();
                      onEnroll();
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        event.stopPropagation();
                        onEnroll();
                      }
                    }}
                    sx={{
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      color: "rgb(152, 52, 240)",
                      cursor: "pointer",
                    }}
                  >
                    Enroll Now
                  </Typography>
                )}
              </Box>
            </AccordionSummary>
            {hasFullCourseAccess && <MarkAsinCompletedText onPress={() => onMarkAsCompleteOrInComplete(isCompleted, isCompleted ? list : _.flatten(item))} isCompleted={isCompleted} />}

            <AccordionDetails>
              {canExpand && (
                item.map((values) => {
                  return values.map((value, id) => {
                    const day = value?.day
                    const dayNumber = day === 1000 ? null : day
                    let contenttype = 0;
                    if (value?.students_course_status?.length == 1) {
                      contenttype = "completed"
                    }
                    else {
                      contenttype = value?.content_type
                    }
                    return (
                      <VideoListView isExpired={isExpired} index={id} item={value} loked={hasFullCourseAccess} contentType={contenttype}
                        onPreviewClick={() => {
                          onNavigatetoPreview(value, item, value?.students_course_status?.length)
                        }} content={value?.content} heading={dayNumber}
                        fileName={value?.document_name ?? value?.content}
                      />

                    )
                  })
                })
              )}
            </AccordionDetails>
          </Accordion>
        )
        })}
      </WaterMark>
    </Box>

  </Box>);
}

export default CourseListCard;